import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {orgId, defaultErrorHandler} from '../../../context/context';
import customFormsV2Client from '../../../infrastructure/acerill/custom-forms-v2-client';
import googleSheetsV1Client from '../../../infrastructure/acerill/google-sheets-v1-client';
import shopifyV1Client from '../../../infrastructure/acerill/shopify-v1-client';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';
import FormSelector from '../../forms/form-selector';
import SaveCancelBar from '../../../libs/react-components-admin/buttons/save-cancel-bar';
import EntitySelector from '../../../libs/react-components-admin/fields/entity-selector';
import Section from '../../../libs/react-components-admin/section/section';
import {TextField} from '../../../libs/react-components-admin/fields/text-like-field';
import TimestampColumn from './timestamp-column';
import Support from './support';

const GoogleSheetsIntegration = () => {

  const {integrationId} = useParams();

  const [model, setModel] = useState();

  useEffect(() => { loadIntegration().catch(defaultErrorHandler); }, []);

  const loadIntegration = () => {
    setModel(null);
    return customFormsV2Client
      .findGoogleSheetsIntegrationById(integrationId)
      .then(integration => {
        if (integration) {
          setModel(integration);
        } else {
          return shopifyV1Client.findShopById(orgId).then(shop =>
            setModel({id: integrationId, support: {emailAddresses: [shop.email]}})
          );
        }
      });
  };

  const isModelValid = () => model.id && model.formId && model.accountId &&
      model.spreadsheetId && model.sheetTitle &&
      ((model.support || {}).emailAddresses || []).length > 0;

  const save = () => customFormsV2Client.saveGoogleSheetsIntegration(model);

  const content = () => <>
    <TextField id="name"
               label="Name"
               helpBlock={<>Helps you identify this integration</>}
               value={model.name}
               onChange={value => setModel({...model, name: value})}/>
    <FormSelector allowNull={false}
                  hideWhenNoChoice={false}
                  initialValue={model.formId}
                  onChange={v => setModel({...model, formId: v})}/>
    <EntitySelector id="accountId"
                    label="Account"
                    fetchEntities={() => googleSheetsV1Client.findAccounts()}
                    errorHandler={defaultErrorHandler}
                    allowNull={false}
                    hideWhenNoChoice={false}
                    initialValue={model.accountId}
                    onChange={v => setModel({...model, accountId: v})}/>
      <TextField id="spreadsheetId"
                 label="Spreadsheet ID"
                 helpBlock={<>The Spreadsheet ID is the long string of characters in the URL of your spreadsheet, before /edit. For example, in the URL https://docs.google.com/spreadsheets/d/1qpyC0XzvTcKT6EISywvqESX3A0MwQoFDE8p-Bll4hps/edit#gid=0, the spreadsheet ID is 1qpyC0XzvTcKT6EISywvqESX3A0MwQoFDE8p-Bll4hps</>}
                 value={model.spreadsheetId}
                 onChange={v => setModel({...model, spreadsheetId: v})}/>
      <TextField id="sheetTitle"
                 label="Sheet title"
                 helpBlock={<>The name of the tab where the data should be appended (at the bottom of the screen in Google Sheets)</>}
                 value={model.sheetTitle}
                 onChange={v => setModel({...model, sheetTitle: v})}/>
      <TimestampColumn value={model.timestampColumn}
                       onChange={v => setModel({...model, timestampColumn: v})}/>
      <Support model={model.support}
               onChange={v => setModel({...model, support: v})}/>
      <div className="w-100 my-5"/>
      <SaveCancelBar saveAction={() => save()}
                     cancelAction={() => loadIntegration()}
                     saveDisabled={!isModelValid()}
                     errorHandler={defaultErrorHandler}/>
    </>;

  return <Section title="Integration - Google Sheets" noMargin={true}>
    {!model ?
      <CenteredSpinner/> :
      <div className="row justify-content-center">
        <div className="col-12 col-md-8">
          {content()}
        </div>
      </div>
    }
  </Section>;
};

export default GoogleSheetsIntegration;
